import { ranking } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-green-500',
  down: 'ri-arrow-down-line text-red-400',
  new: 'ri-flashlight-line text-accent-500',
  stable: 'ri-subtract-line text-foreground-400',
};

const rankNumbers: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-primary-400 text-background-50',
  3: 'bg-primary-300 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Hot Ranking</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">热播榜单</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">8090后都在看什么？实时热度排行榜告诉你答案</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {ranking.map((item) => (
            <article key={item.rank} className="bg-background-100 rounded-lg overflow-hidden border border-secondary-200/60 group cursor-pointer hover:border-primary-300/40 transition-colors">
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${rankNumbers[item.rank] || 'bg-secondary-300 text-foreground-600'}`}>
                    {item.rank}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-xs bg-background-50/80 backdrop-blur-sm text-foreground-800 px-2 py-0.5 rounded-full">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-1">{item.title}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.hot} 热度</span>
                  <i className={`text-sm ${trendIcons[item.trend] || trendIcons.stable}`}></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}